module.exports = __webpack_public_path__ + "img/motoscafoWhite.33f8447c.svg";